


export default {
    state : ()=>{
        return {
            lang:'zh'
        }
    },
    mutations:{
        updateLang(state,name){
            state.lang = name;
        }
    }
}